import {object, string} from 'yup';

import {DEFAULT_REQUIRED_MESSAGE} from 'shared/helpers/validationSchemas';

const MAX_ABBREV_LENGTH = 3;
export const subcontractorsSchema = object().shape({
  name: string().required(DEFAULT_REQUIRED_MESSAGE),
  abbrev: string().max(MAX_ABBREV_LENGTH).trim(),
});
